import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { fetchRecords } from './actions'
import { ensureMeta } from '../../shared/actions/meta';
import './record.css';
import edit from '../../shared/images/edit.svg';

// {host}/record/find/{collectionId}

class LocateByCollection extends Component {
    componentWillMount(){
        let id = this.props.match.params.collectionId;
        this.props.dispatch(ensureMeta(id));
        this.props.dispatch(fetchRecords(id));
    }

    state = {
        redirectTo: null
    };

    onItemClicked = (e) => {
        e.preventDefault();
        const { currentTarget } = e;

        switch(currentTarget.dataset.cap)
        {
            case 'RecordCapabilities.CREATE':
                this.setState({ redirectTo: '/app/record/create/' + currentTarget.dataset.col });
                break;
            case 'RecordCapabilities.EDIT':
                this.setState({ redirectTo: '/app/record/edit/' + currentTarget.dataset.rec });
                break;
            default:
                // TODO: Display message to user
                break;
        }
    }

    render() {
        if (this.state.redirectTo){
            return <Redirect to={this.state.redirectTo} />
        }
        if (this.props.availableRecords && this.props.availableRecords.length > 0) {
            var recs = this.props.availableRecords.map(r =>
                <li className="ac-card" key={r.recordId} data-rec={r.recordId} data-col={r.collectionId} data-cap={r.capabilities} onClick={this.onItemClicked}>
                    <div className="ac-iconned">
                        <div className="ac-icon-container-left">
                            <img className="ac-icon-med ac-icon-centered" src={edit} alt="edit" />
                        </div>
                        <div>
                            <label>{r.title}</label><p className="ac-pre">{r.summary}</p>
                        </div>
                    </div>
                </li>);

            return <div className="ac-page">
                <div className="ac-wizard">
                    <div className="ac-wizard-header">
                        <h2>Select your {this.props.recordName}</h2>
                    </div>
                    <div className="ac-wizard-body">
                        <ul className="ac-card-list">{recs}</ul>
                    </div>
                    <div className="ac-wizard-nav">
                    </div>
                </div>
            </div>
        }
        else {

            return <div>loading...</div>
        }
    }
}

function mapStateToProps(state) {
    return {
        availableRecords: state.components.record.availableRecords,
        recordName: state.meta ? state.meta.friendlyName : ''
    };
}

export default connect(mapStateToProps)(LocateByCollection);